import type * as React from "react"

const CHECKLIST_ITEM_STATUSES = {
  NOT_STARTED: "not_started",
  IN_PROGRESS: "in_progress",
  DONE: "done"
} as const

type ChecklistItemStatusesKeys = keyof typeof CHECKLIST_ITEM_STATUSES
type ChecklistItemStatuses =
  (typeof CHECKLIST_ITEM_STATUSES)[ChecklistItemStatusesKeys]

const CHECKLIST_ITEM_STATUSES_MAP: Record<
  ChecklistItemStatuses,
  {
    id: ChecklistItemStatuses
    value: ChecklistItemStatuses
    label: string
    style: React.CSSProperties
  }
> = {
  [CHECKLIST_ITEM_STATUSES.NOT_STARTED]: {
    id: CHECKLIST_ITEM_STATUSES.NOT_STARTED,
    value: CHECKLIST_ITEM_STATUSES.NOT_STARTED,
    label: "Not Started",
    style: {
      color: "#616d73",
      backgroundColor: "#ECEFF1",
      borderColor: "#ECEFF1"
    }
  },
  [CHECKLIST_ITEM_STATUSES.IN_PROGRESS]: {
    id: CHECKLIST_ITEM_STATUSES.IN_PROGRESS,
    value: CHECKLIST_ITEM_STATUSES.IN_PROGRESS,
    label: "In Progress",
    style: {
      color: "#9E5E00",
      backgroundColor: "#FFF3E0",
      borderColor: "#FFF3E0"
    }
  },
  [CHECKLIST_ITEM_STATUSES.DONE]: {
    id: CHECKLIST_ITEM_STATUSES.DONE,
    value: CHECKLIST_ITEM_STATUSES.DONE,
    label: "Done",
    style: {
      color: "#367B38",
      backgroundColor: "#E8F5E9",
      borderColor: "#E8F5E9"
    }
  }
}

const CHECKLIST_ITEM_PRIORITIES = {
  LOW: 1,
  MEDIUM: 2,
  HIGH: 3,
  CRITICAL: 4
} as const

type ChecklistItemPrioritiesKeys = keyof typeof CHECKLIST_ITEM_PRIORITIES
type ChecklistItemPriority =
  (typeof CHECKLIST_ITEM_PRIORITIES)[ChecklistItemPrioritiesKeys]

const CHECKLIST_ITEM_PRIORITIES_MAP: Record<
  ChecklistItemPriority,
  {
    id: ChecklistItemPriority
    value: ChecklistItemPriority
    label: string
    style: React.CSSProperties
  }
> = {
  [CHECKLIST_ITEM_PRIORITIES.LOW]: {
    id: CHECKLIST_ITEM_PRIORITIES.LOW,
    value: CHECKLIST_ITEM_PRIORITIES.LOW,
    label: "Low",
    style: {
      color: "#2E7D32",
      backgroundColor: "#E8F5E9",
      borderColor: "#E8F5E9"
    }
  },
  [CHECKLIST_ITEM_PRIORITIES.MEDIUM]: {
    id: CHECKLIST_ITEM_PRIORITIES.MEDIUM,
    value: CHECKLIST_ITEM_PRIORITIES.MEDIUM,
    label: "Medium",
    style: {
      color: "#A26604",
      backgroundColor: "#FFFDE7",
      borderColor: "#FFFDE7"
    }
  },
  [CHECKLIST_ITEM_PRIORITIES.HIGH]: {
    id: CHECKLIST_ITEM_PRIORITIES.HIGH,
    value: CHECKLIST_ITEM_PRIORITIES.HIGH,
    label: "High",
    style: {
      color: "#B45100",
      backgroundColor: "#FFF3E0",
      borderColor: "#FFF3E0"
    }
  },
  [CHECKLIST_ITEM_PRIORITIES.CRITICAL]: {
    id: CHECKLIST_ITEM_PRIORITIES.CRITICAL,
    value: CHECKLIST_ITEM_PRIORITIES.CRITICAL,
    label: "Critical",
    style: {
      color: "#C62828",
      backgroundColor: "#FFEBEE",
      borderColor: "#FFEBEE"
    }
  }
}

export {
  CHECKLIST_ITEM_STATUSES,
  CHECKLIST_ITEM_PRIORITIES,
  CHECKLIST_ITEM_STATUSES_MAP,
  CHECKLIST_ITEM_PRIORITIES_MAP,
  type ChecklistItemStatuses,
  type ChecklistItemPriority
}
